import { HiInformationCircle, HiCube, HiAdjustments } from "react-icons/hi";
import Sidebar from "components/Sidebar/Sidebar";
import { useTranslation } from "react-i18next";

interface SettingsSidebarProps {
  settingsType: "global" | "organization";
  basePath: string;
}

const SettingsSidebar: React.FC<SettingsSidebarProps> = ({ settingsType, basePath }) => {
  const { t } = useTranslation();
  const isGlobal = settingsType === "global";
  const titlePrefix = isGlobal ? t("settings.global") : t("settings.organization");
  
  const items = [
    {
      path: basePath,
      label: t("settings.sidebar.info"),
      icon: <HiInformationCircle className="h-5 w-5" />,
    },
    {
      path: `${basePath}/model`,
      label: t("settings.sidebar.model"),
      icon: <HiCube className="h-5 w-5" />,
    },
    {
      path: `${basePath}/model-assignment`,
      label: t("settings.sidebar.modelAssignment"),
      icon: <HiAdjustments className="h-5 w-5" />,
    },
  ];

  const isActiveItems = (itemPath: string) => {
    const currentPath = window.location.pathname;
    if (currentPath === itemPath) return true;
    if (itemPath === basePath) {
      return currentPath === `${basePath}/`;
    }
    return false;
  };

  const ProfileSection = (
    <div className="flex flex-col items-center justify-center px-6 py-5">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-navy-700 dark:text-white">
          {t("settings.sidebar.title", { type: titlePrefix })}
        </h3>
      </div>
    </div>
  );

  return (
    <Sidebar
      items={items}
      isActiveItems={isActiveItems}
      ProfileSection={ProfileSection}
    />
  );
};

export default SettingsSidebar;
